export { default } from './StepLabel';


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/core/esm/StepLabel/index.js
// module id = 560
// module chunks = 2